import { ChecklistFiltersValue } from './checklist-filters';

const FILTER_FIELDS: Array<[keyof ChecklistFiltersValue, string]> = [
  ['eventId', 'EventId'],
  ['location', 'Location'],
  ['instructor', 'Instructor'],
  ['status', 'Status'],
  ['comment', 'Comment']
];

const escapeODataValue = (value: string) => value.replace(/'/g, "''").toLowerCase();

export const buildChecklistReportFilter = (filters: ChecklistFiltersValue): string | undefined => {
  const expressions: string[] = [];

  FILTER_FIELDS.forEach(([key, field]) => {
    const filterValue = filters[key];
    const values = (Array.isArray(filterValue) ? filterValue : [filterValue]).filter(
      (value): value is string => typeof value === 'string' && value.trim().length > 0
    );
    if (values.length === 0) return;

    const fieldExpressions = values.map(value => `contains(tolower(${field}),'${escapeODataValue(value.trim())}')`);
    expressions.push(values.length === 1 ? fieldExpressions[0] : `(${fieldExpressions.join(' or ')})`);
  });

  const eventTypeIds = (filters.eventTypeIds || []).filter(Boolean);
  if (eventTypeIds.length > 0) {
    const eventTypeExpressions = eventTypeIds.map(id => `EventTypeId eq ${id}`);
    expressions.push(eventTypeExpressions.length === 1 ? eventTypeExpressions[0] : `(${eventTypeExpressions.join(' or ')})`);
  }

  const checklistItemIds = (filters.checklistItemIds || []).filter(Boolean);
  if (checklistItemIds.length > 0) {
    const checklistItemExpressions = checklistItemIds.map(id => `CheckListItemId eq ${id}`);
    expressions.push(checklistItemExpressions.length === 1 ? checklistItemExpressions[0] : `(${checklistItemExpressions.join(' or ')})`);
  }

  const machineModelIds = (filters.machineModelIds || []).filter(Boolean);
  if (machineModelIds.length > 0) {
    const machineModelExpressions = machineModelIds.map(id => `machineModelIds/any(id:id eq ${id})`);
    expressions.push(machineModelExpressions.length === 1 ? machineModelExpressions[0] : `(${machineModelExpressions.join(' or ')})`);
  }

  return expressions.length > 0 ? expressions.join(' and ') : undefined;
};
